module.exports = __webpack_public_path__ + "static/media/textOnlyCard.4a4382ee.svg";